/**
 * initFoldbox
 */
window.initFoldbox = function () {
    const foldboxItem = $('.foldbox');

    if (foldboxItem.length) {
        // defold alle ohne die Klasse foldbox--open
        $('.foldbox:not(.foldbox--open) .foldbox__content').hide();

        foldboxItem.find('.foldbox__trigger').off('click').on('click', function (e) {
            e.preventDefault();
            const foldTrigger = $(this);
            foldTrigger.closest('.foldbox').toggleClass('foldbox--open').find('.foldbox__content').slideToggle(100);
        });
    }
};